/**
 * Get the numeric value from a string
 * @example
 * "-45.67" => -45.67
 * "abc" => 0
 * "abc 123 def" => 123
 * "x=123" => 123
 */
export const getNumericValue = (value: string) =>
  Number(value.match(/[+-]?\d+(\.\d+)?/g)) || 0;
